/** Styling shared by input widgets. */
export const CHAT_INPUT_WIDGET = {
    maxWidth: 345,
    borderRadius: 24,
    paddingTop: 24,
    paddingBottom: 12,
    rowPaddingHorizontal: 16,
    rowPaddingVertical: 4,
    rowMinHeight: 40,
    rowGap: 12,
} as const;

/** Shared bubble styling for user messages and suggestion pills. */
export const CHAT_USER_BUBBLE = {
    backgroundColor: 'rgba(174, 212, 202, 0.90)',
    borderRadius: 20,
    paddingHorizontal: '$4',
    paddingVertical: 10,
} as const;
